import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import Config from 'config/settings';
import { DepartmentType } from 'app/data/Enums';
import { LookupType, ParticleLayoutType } from 'app/enum/Particles';
import { HomeField } from 'app/views/home/webgl/particles/fields/HomeField';
import HomeFieldConfig from 'app/views/home/webgl/particles/config/HomeFieldConfig';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';
import DelayHelper from 'utils/timers';
import HomeColours from 'app/views/home/config/HomeColours';
import { device } from 'utils/device';

//100ish particles that move with scene. Select from 1st hundred in field and reserve
//The rest of the particles are more fixed in place
//1. Around the icon (following mouse etc)
//2. In the spaces scene as particles with different z depths
//3. On the screens broken grid
//4. On work after following down to
export default class TransitionParticles {
	private _transitionParticles: Array<HomeParticle>;
	private _extraIconParticles: Array<HomeParticle>;
	private _active: boolean = true;
	private _screensIsometricGridPositions: Array<geometry.Vector2>;
	private _screensRegularGridPositions: Array<geometry.Vector2>;
	private _gridLines: PIXI.Sprite;
	private _gridLinesGraphic: PIXI.Graphics;
	private _transitionsParticleContainer: PIXI.Container;

	private _canProcessDragUpdate: boolean = false;
	private _dragMinAlpha: number = 0;

	private _sineLookup: Array<particles.ParticleLookupProps>;
	private _processSine: boolean = false;
	private _sineIndex: number = 0;
	private _spacesLurkProps: Array<any> = [];
	private _spacesLurkY: number = 0;

	constructor(
		private _homeField: HomeField,
		private _sceneProps: particles.ParticlesSceneProps
	) {
		this._createParticleSet();
		this._transitionsParticleContainer = this._homeField.getSubContainer('transitions');


		this._gridLinesGraphic = new PIXI.Graphics();
		this._gridLines = new PIXI.Sprite();
		this._gridLines.name = 'Grid Lines';
		this._gridLines.addChild(this._gridLinesGraphic);
		this._transitionsParticleContainer.addChildAt(this._gridLines, 0);
		this._gridLines.alpha = Config.workScreensGridAlpha;
	}

	public tick() {
		if (!this._active) return;


		if (this._processSine) {
			this._processSineWave();
		}
	}

	public toIcon() {
		return;

		let x = 0.33;
		let y = 0.0;
		let w = 0.345;
		let h = 1;

		x = 0.495;
		y = 0.45;
		w = 0.001;
		h = 0.001;

		this._homeField.reposition(
			ParticleLayoutType.RANDOM,
			{ x: x, y: y },
			{ w: w, h: h },
			null,
			this._transitionParticles,
			0,
			false,
			(p: HomeParticle) => {
				this._toIconParticle(p, -1, true);
			}
		);

		this._homeField.particles.forEach((p: HomeParticle) => {
			this._toIconParticle(p, -1, true);
		});



		this._extraIconParticles = HomeFieldConfig.getParticlePool(
			this._homeField.particles as Array<HomeParticle>,
			'screens'
		).splice(0, HomeFieldConfig.extraIconOutterParticles);
		this._homeField.reposition(
			ParticleLayoutType.RANDOM,
			{ x: x, y: y },
			{ w: w, h: h },
			null,
			this._extraIconParticles,
			0,
			false,
			(p: HomeParticle) => {
			}
		);

		this._transitionParticles.forEach((particle) => {
			particle.orbitPath.speed = 0;
		});

		this._extraIconParticles.forEach((particle) => {
			particle.orbitPath.speed = 0;
		});
	}

	public toSpaces() {


		//Reset the icon particles
		this._extraIconParticles = null;
	}

	public toScreens() {



		//Reset the icon particles
		this._extraIconParticles = null;
	}

	public updateWorkTransitionParticles(introXPx: number, introProgressRatio: number): void {
		if (!this._canProcessDragUpdate) {
			return;
		}

		if (this._processSine) {
			this._gridLines.alpha = Math.max(0, Config.workScreensGridAlpha * (1 - introProgressRatio));

			this._transitionsParticleContainer.alpha = Math.max(this._dragMinAlpha, 1 - introProgressRatio);

			this._homeField.getRelativeWidth(introXPx) * 0.75;

			this._transitionParticles.forEach((particle, index) => {
			});
		} else {
			this._transitionsParticleContainer.x = introXPx * 0.75;
			this._transitionsParticleContainer.alpha = Math.max(this._dragMinAlpha, 1 - introProgressRatio);
		}
	}

	private _particleToScreens(index: number): void {
		return;
		let p: HomeParticle = this._transitionParticles[index];

		let position: geometry.Vector2 = this._screensRegularGridPositions[index];

		if (p) {
			p.switching = 'screens';
			p.deactivateAllBehaviours(true);
			let ease = p.random(20, 5);
			p.animatedProps.setEase({ x: ease, y: ease / 4 }, true, 20);

			//STOPS SWING back to center, which looks nice on spaces
			p.position.clamp();
			p.position.set(
				{
					y: position.y,
					x: p.position.x
				},
				true
			);

			p.position.lerp(position, p.random(50, 30), (p: HomeParticle) => {
				p.animatedProps.targetAlpha = p.random(0.4, 0.5);
				p.animatedProps.targetScale = p.random(0.1, 0.08);
				p.canDrawLine = true;
				p.repell.active = false;
				p.repell.returnPower = { x: 0.035, y: 0.035 };
				p.repell.returnTo = position;
			});

			p.repell.active = false;

			p.moveSeed = p.random(1, 0.2);
			p.sineSeed = p.random(0.4, 0.8);
		}
	}

	private _startSine() {
		this._sineLookup = this._sceneProps.lookups.sine.table;
		this._processSine = true;
		this._transitionParticles.forEach((particle, index) => {
			particle.animatedProps.setEase({ y: particle.random(10, 20) });
		});
	}

	private _processDragUpdate() {
		this._canProcessDragUpdate = true;
	}

	public setShares(shares: any) {
		//Get Spaces top down
		//Get Screens bottom up

		return;
		let icons: Array<HomeParticle>;
		if (shares.screens) {
			let screens: Array<HomeParticle> = this._transitionParticles.slice(0, shares.screens);
			screens.forEach((particle: HomeParticle, index: number) => {
				if (particle.switching != 'screens') {
					this._particleToScreens(index);
				}
			});

			icons = this._transitionParticles.slice(shares.screens);
		} else if (shares.spaces) {
			let spaces: Array<HomeParticle> = this._transitionParticles.slice(-1 * shares.spaces);
			spaces.forEach((particle: HomeParticle, index: number) => {
				if (particle.switching != 'spaces') {
					this._toSpacesParticle(particle, false, index);
				}
			});

			icons = this._transitionParticles.slice(0, this._transitionParticles.length - shares.spaces);
		} else {
			icons = this._transitionParticles;
		}

		icons.forEach((particle: HomeParticle, index: number) => {
			if (particle.switching != 'icon') {
				this._toIconParticle(particle, index);
			}
		});
	}

	public toWork(department: DepartmentType) {
		return;
		let moveY = device.innerHeight;

		if (department === DepartmentType.SCREENS) {
			return;

			gsap.TweenMax.to(this._transitionsParticleContainer, Config.toWorkTime, {
				pixi: { y: -1.4 * moveY },
				ease: Config.toWorkEase,
				onComplete: () => {
					gsap.TweenMax.to(this._transitionsParticleContainer, 0.4, {
						pixi: { y: -1 * moveY },
						ease: Config.linearEase
					});
				}
			});

			this._fadeGridPartcilesToScreensWork();
			DelayHelper.setTimeout(() => {
				this._moveGridPartcilesToScreensWork();
			}, Config.toWorkTime * 500);

			this._hideGridForWork();

			DelayHelper.setTimeout(() => {
				gsap.TweenMax.to(this._gridLines, 4, {
					pixi: { alpha: Config.workScreensGridAlpha },
					ease: Config.linearEase
				});
			}, 500);

			DelayHelper.setTimeout(() => {
				this._startSine();
			}, 2200);

			DelayHelper.setTimeout(() => {
				this._processDragUpdate();
			}, 3500);
		} else {

			this._transitionParticles.forEach((particle, index) => {
				if (!this._spacesLurkProps[index]) {
					this._spacesLurkProps[index] = {
						x: particle.position.x,
						y: particle.position.y,
						scale: particle.animatedProps.targetScale,
						alpha: particle.animatedProps.targetAlpha
					};
				}

				DelayHelper.setTimeout(
					() => {
						particle.position.lerp(
							{ y: 0.1 + Math.random() * 0.8, x: particle.position.x },
							particle.random(30, 120),
							(particle: HomeParticle) => {
								this._canProcessDragUpdate = true;
							}
						);
					},
					Config.toWorkTime * particle.random(0, 50)
				);

				particle.animatedProps.setEase({ x: particle.random(10, 10), y: particle.random(10, 10) }, true, 70);
				particle.animatedProps.setEase({ alpha: 40 });
				particle.animatedProps.targetAlpha = particle.animatedProps.targetAlpha += 0.12;
				particle.moveSpeed = particle.random(0.4, 0.8);

				if (particle.animatedProps.targetScale > 0.25) {
					particle.animatedProps.targetScale *= 0.5;
				}
			});
		}
	}

	public fromWorkToHome(department: DepartmentType): void {
		this._transitionParticles.forEach((particle, index) => {
			particle.animatedProps.stopBreathing();
			particle.animatedProps.targetScale = 0;
		});

		DelayHelper.setTimeout(() => {
			this._transitionParticles.forEach((particle, index) => {
				particle.deactivate();
			});
		}, 1000);

		this._canProcessDragUpdate = false;
		this._processSine = false;

		return;

		if (department === DepartmentType.SCREENS) {
			gsap.TweenMax.to(this._transitionsParticleContainer, 1, { pixi: { alpha: 1, ease: Config.linearEase } });

			gsap.TweenMax.to(this._gridLines, 0.4, {
				pixi: { alpha: Config.workScreensGridAlpha },
				ease: Config.linearEase,
				onComplete: () => {
					this._setWorkGridLines();
				}
			});

			this._fadeGridPartcilesToScreensWork();

			gsap.TweenMax.to(this._transitionsParticleContainer, Config.toWorkTime, {
				pixi: { y: 0 },
				ease: Config.toWorkEase,
				onComplete: () => {}
			});

			DelayHelper.setTimeout(() => {
				this._transitionParticles.forEach((particle, index) => {
					particle.canDrawLine = false;
					particle.position.set({ x: this._screensRegularGridPositions[index].x, y: particle.position.y }, true);

					particle.animatedProps.alpha = 0;
					particle.animatedProps.targetAlpha = Config.spacesParticleAlpha;
					particle.animatedProps.setEase({ alpha: 40 });

					particle.position.lerp(
						{ x: this._screensRegularGridPositions[index].x, y: this._screensRegularGridPositions[index].y },
						particle.random(50, 30),
						() => {
							particle.canDrawLine = true;
						}
					);

					if (Math.random() < 0.75) {
						DelayHelper.setTimeout(
							() => {
								particle.canDrawLine = true;
							},
							particle.random(300, 500)
						);
					}

					particle.animatedProps.setEase({ x: particle.random(2, 1), y: particle.random(10, 10) }, true, 20);

				});
			}, 500);
		} else {
			this._transitionParticles.forEach((particle, index) => {
				DelayHelper.setTimeout(
					() => {
						particle.position.lerp(
							{ y: this._spacesLurkY, x: this._spacesLurkProps[index].x },
							particle.random(30, 120),
							(particle: HomeParticle) => {}
						);
					},
					Config.toWorkTime * particle.random(0, 50)
				);

				particle.animatedProps.setEase({ x: particle.random(10, 10), y: particle.random(10, 10) }, true, 70);
				particle.animatedProps.setEase({ alpha: 40 });
				particle.animatedProps.targetAlpha = this._spacesLurkProps[index].alpha;
				particle.moveSpeed = particle.random(0.4, 0.8);
				particle.animatedProps.targetScale = this._spacesLurkProps[index].scale;
			});

			gsap.TweenMax.to(this._transitionsParticleContainer, Config.toWorkTime * 2, {
				pixi: { x: 0 },
				ease: Config.linearEase
			});
		}
	}

	//NOTE: these two hooks used to loop the particle sets calling
	//particle.transitions.startSceneDrag()/endSceneDrag() — modelled on
	//IconDepartment's particle.icon.* hooks — but HomeParticle has never had a
	//`transitions` per-particle processor (only spaces/screens/systems/icon/
	//intro), so the calls would have thrown had they ever run. They never do:
	//no code anywhere invokes these methods. Kept as documented no-ops; if a
	//TransitionParticleProcessor is ever built, restore the loops.
	public startSceneDrag() {}

	public endSceneDrag() {}

	//When coming back from work deactivate the particles
	public showFromWork(department: DepartmentType) {
		return;
		DelayHelper.setTimeout(
			() => {
				this._transitionParticles.forEach((particle) => {
				});
			},
			1000,
			null,
			'transition'
		);
	}

	//Deeplink to work, need to load the particle
	public setupForWork(department: DepartmentType) {
		this._canProcessDragUpdate = true;
		this._dragMinAlpha = 1;

		this._transitionParticles.forEach((particle) => {
			particle.activate();
			particle.setVisible(true);
			particle.active = true;
			particle.animatedProps.alpha = 0;
			particle.animatedProps.scale = 0;
			particle.animatedProps.targetAlpha = 1;
			particle.animatedProps.targetScale = 1;
			particle.moveSeed = particle.random(1, 0.2);
			particle.position.set({ x: 0.36, y: 0.5 }, true);

			particle.orbitPath.active = true;
			particle.orbitPath.expandMuliplier = 0;
			particle.orbitPath.xMuliplier = 0;
			particle.orbitPath.xMuliplier = 0;

			if (department == DepartmentType.SPACES) {
				particle.orbitPath.path = LookupType.CIRCLE;
			} else {
				particle.orbitPath.path = LookupType.RECT;
			}

			particle.orbitPath.randomise(true, true);



			particle.colour.set(HomeColours.getRandomColour(HomeColours.dynamicSets.m4g));

			particle.animatedProps.setEase({
				x: 30,
				y: 30
			});

			setTimeout(() => {
				particle.orbitPath.active = true;
				particle.animatedProps.targetAlpha = 0.2 + Math.random() * 0.6;
				particle.animatedProps.targetScale = 0.2 + Math.random() * 0.15;
				particle.orbitPath.speed = 1;
				particle.position.set({ x: 0.375, y: 0.5 }, true);

				if (department == DepartmentType.SPACES) {
					particle.orbitPath.speedMuiliplier = 0.001 + Math.random() * 0.04;
					particle.orbitPath.xMuliplier = 300;
					particle.orbitPath.yMuliplier = 200;
					particle.orbitPath.expandMuliplier = 0.7 + Math.random() * 1.7;

					particle.animatedProps.targetAlpha = 0.1 + Math.random() * 0.4;
					particle.animatedProps.targetScale = 0.15 + Math.random() * 0.05;
				} else {
					particle.orbitPath.speedMuiliplier = 0.1 + Math.random() * 0.3;
					particle.orbitPath.xMuliplier = 700 + Math.random() * 300;
					particle.orbitPath.yMuliplier = 350 + Math.random() * 600;

					particle.orbitPath.xMuliplier = 600 + Math.random() * 4300;
					particle.orbitPath.yMuliplier = Math.random() * 950;

					particle.orbitPath.expandMuliplier = 1;
					particle.animatedProps.targetAlpha = 0.15 + Math.random() * 0.5;
					particle.animatedProps.targetScale = 0.15 + Math.random() * 0.1;
					particle.animatedProps.setEase({
						x: 10,
						y: 10
					});
				}

				particle.animatedProps.startBreathing(
					particle.animatedProps.targetScale,
					0.001 + Math.random() * 0.01,
					Math.random() * 0.3
				);
			}, 0);

			setTimeout(() => {
				particle.animatedProps.setEase({
					scale: 30,
					alpha: 30
				});

				particle.animatedProps.setEase({
					x: 100
				});
				particle.animatedProps.targetAlpha = 0.2 + Math.random() * 0.3;
				particle.animatedProps.targetScale = 0.15 + Math.random() * 0.1;
			}, 1000);

		});

		setTimeout(() => {
			let tweenOb = { value: this._dragMinAlpha };
			gsap.TweenMax.to(tweenOb, 3, {
				value: 0.4,
				ease: Config.linearEase,
				onUpdate: () => {
					this._dragMinAlpha = tweenOb.value;
					console;
				}
			});
		}, 1000);

		return;

		if (department === DepartmentType.SCREENS) {
			this._setupForWorkScreens();
			return;
		}

		this._setupForWorkSpaces();
	}

	//PRIVATE
	//--------------------------------------------------------------------------------------------------
	//--------------------------------------------------------------------------------------------------
	//--------------------------------------------------------------------------------------------------
	//--------------------------------------------------------------------------------------------------

	private _toIconParticle(particle: HomeParticle, index: number = 1, fromIntro: boolean = false) {
		particle.switching = 'icon';
	}

	private _createParticleSet() {
		//Reserve 1st 100 or so for transitions and mouse following etc:
		let transitionParticleCount = HomeFieldConfig.transitionParticles;
		this._transitionParticles = this._homeField.particlesFromIndex(0, transitionParticleCount) as Array<HomeParticle>;

		let layout = this._sceneProps.layouts.isometric;
		this._screensIsometricGridPositions = layout.get(
			this._transitionParticles.length,
			{ x: 0, y: 0.2 },
			{ w: 0.2, h: 0.1 }
		);
		this._screensRegularGridPositions = this._sceneProps.layouts.grid.get(
			this._transitionParticles.length,
			{ x: 0, y: 0.3 },
			{ w: 0.25, h: 0.5 },
			{ cols: 10 }
		);
	}

	//Set oscillating grid / sine wave with transition particles:
	private _setupForWorkScreens(): void {
		this._transitionsParticleContainer.y = -1 * device.innerHeight;
		this._moveGridPartcilesToScreensWork();
		this._setWorkIsoGridLines();

		this._transitionParticles.forEach((particle) => {
			particle.active = true;
			particle.animatedProps.alpha = 0.3;
			particle.animatedProps.scale = 0.4;
			particle.animatedProps.targetAlpha = 0.5;
			particle.animatedProps.targetScale = 0.4;
			particle.moveSeed = particle.random(1, 0.2);
			particle.sineSeed = particle.random(0.4, 0.8);
		});
	}

	//Set spaces transition particles state:
	private _setupForWorkSpaces(): void {

		return;
		this._transitionParticles.forEach((particle, index) => {
			particle.active = true;
			this._toSpacesParticle(particle, true, index);
		});
	}

	/**
	 * Show home particle as scene slides back in
	 * Only icon is currently showing
	 *
	 * NOTE: doubly dead. The whole "lurk on spaces" choreography that lived
	 * here (velocity-dampened drop of each particle to a random x/y band by
	 * lurkDepth, then particle.transitions.setSpacesStartLurk() /
	 * lurkOnSpaces(), recording _spacesLurkProps/_spacesLurkY) was (1) behind
	 * an unconditional `return;` and (2) built on a per-particle `transitions`
	 * processor that HomeParticle has never had — it would have thrown had it
	 * ever run. Its only caller, _setupForWorkSpaces above, is itself disabled
	 * by an early return. Body removed rather than left untypecheckable; see
	 * git history for the full choreography if it is ever rebuilt.
	 */
	private _toSpacesParticle(particle: HomeParticle, isDeeplinkToSpaces: boolean, index: number) {}




	private _fadeGridPartcilesToScreensWork(): void {
		this._transitionParticles.forEach((p, index) => {
			p.animatedProps.targetAlpha = 0;
			p.animatedProps.setEase({ alpha: 30 });
		});
	}

	private _moveGridPartcilesToScreensWork(): void {
		this._transitionParticles.forEach((p, index) => {
			let position = this._screensIsometricGridPositions[index];

			if (position) {
				p.deactivateAllBehaviours(true);
				p.repell.returnTo = null;

				//Just want the x to animate as x movment looks messy:
				p.position.set({ x: position.x, y: p.position.y }, true);
				p.animatedProps.alpha = 0;
				p.animatedProps.targetAlpha = Config.spacesParticleAlpha;

				p.animatedProps.setEase({ y: p.random(10, 15), alpha: 40 });

				p.position.lerp({ x: position.x, y: position.y + 1 }, p.random(30, 30), () => {
					p.animatedProps.setEase({ x: p.random(2, 1), y: p.random(5, 5) }, true, 90);
					DelayHelper.setTimeout(
						() => {
							p.canDrawLine = true;
						},
						p.random(100, 200)
					);
				});
			}
		});
	}

	/** Hide grid when moving to work   */
	private _hideGridForWork(): void {
		gsap.TweenMax.to(this._gridLines, 0.4, {
			pixi: { alpha: 0 },
			ease: Config.linearEase,
			onComplete: () => {
				this._setWorkIsoGridLines();
			}
		});
	}

	//Grid is hidden, can show
	private _setWorkGridLines(): void {
		this._gridLines.alpha = Config.workScreensGridAlpha;
	}

	//Grid is hidden, can show
	private _setWorkIsoGridLines(): void {
		this._gridLines.alpha = Config.workScreensGridAlphaOnWork;
		this._transitionParticles.forEach((p: HomeParticle) => {
			p.canDrawLine = false;
		});
	}

	private _processSineWave(): void {
		this._sineIndex++;
		if (this._sineIndex >= this._sineLookup.length) {
			this._sineIndex = 0;
		}

		let total = this._transitionParticles.length;
		this._transitionParticles.forEach((particle, index) => {
			let transformedIndex = this._sineIndex + Math.round(this._sineLookup.length * (index / total));
			if (transformedIndex >= this._sineLookup.length) transformedIndex -= this._sineLookup.length;

			let yEffect = this._homeField.getRelativeHeight(this._sineLookup[transformedIndex].y) * 16 * particle.sineSeed;

			if (this._screensIsometricGridPositions[index]) {
				particle.position.y = this._screensIsometricGridPositions[index].y + 1 + yEffect;
			}
		});
	}
}
